<template>
  <div class="container" style="flex-direction: row">
    <input
      type="checkbox"
      class="chkbox"
      v-if="$store.state.hasInternet"
      @change="$emit('click')"
      :checked="checked"
      :disabled="disabled"
    />
    <div style="padding: 0px 8px; flex: 1">
      <div
        class="flex"
        style="
          font-size: 13px;
          justify-content: space-between;
          color: #000;
          font-size: 13px;
        "
      >
        <b
          ><p>
            {{ $t("personalArea.extArea.versionUpgrade") }} >> {{ productKey }}
          </p></b
        >
        <p>
          {{ price.toLocaleString() }}
          {{ userSettings.settings["language"] == "en" ? "$ " : "₪ " }}
        </p>
      </div>
      <div
        class="flex"
        style="font-size: 11px; justify-content: space-between; color: #7b7b7b"
      >
        <p class="open-list" @click="openList">
          {{ $t("personalArea.extArea.openNewBooksList") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "name",
    "books",
    "price",
    "checked",
    "disabled",
    "packageVersion",
    "productKey",
  ],
  methods: {
    openList() {
      console.log(this.productKey.split("-"));

      window.open(
        `https://www.otzar.org/internetsite/new-books-${
          this.productKey.split("-")[1].split(".")[0]
        }.pdf`
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 8px 0px;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.05);
  margin-bottom: 8px;
}
p {
  margin: 0px;
}
.open-list {
  color: rgba(0, 0, 0, 0.7);
  font-size: 9px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  border-radius: 20px;
  background: rgba(0, 0, 0, 0.05);
  padding: 2px 5px;
  cursor: pointer;
}
.chkbox {
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.05);
  opacity: 1;
  position: relative;
  height: auto;
  width: auto;
}
</style>
